var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { staticClass: "fill-height" },
    [
      _c(
        "v-col",
        [
          _c(
            "v-card",
            {
              class: { "grey lighten-2": _vm.dragover },
              attrs: { flat: "" },
              on: {
                drop: function ($event) {
                  $event.preventDefault()
                  return _vm.fileUploadSubmit($event)
                },
                dragover: function ($event) {
                  $event.preventDefault()
                  _vm.dragover = true
                },
                dragenter: function ($event) {
                  $event.preventDefault()
                  _vm.dragover = true
                },
                dragleave: function ($event) {
                  $event.preventDefault()
                  _vm.dragover = false
                },
              },
            },
            [
              _vm.$async.upload.$pending || _vm.isFilesLoading
                ? _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "fill-height",
                          attrs: {
                            "align-content": "center",
                            justify: "center",
                          },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "text-subtitle-1 text-center",
                              attrs: { cols: "12" },
                            },
                            [_vm._v(" Идет загрузка файлов ")]
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("v-progress-linear", {
                                attrs: {
                                  color: "primary",
                                  indeterminate: "",
                                  rounded: "",
                                  height: "6",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "v-card-text",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "d-flex flex-column",
                          attrs: {
                            dense: "",
                            align: "center",
                            justify: "center",
                          },
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "pointer",
                              attrs: { for: "upload-file" },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  class: [_vm.dragover ? "mt-2, mb-6" : "mt-5"],
                                  attrs: { size: "60" },
                                },
                                [_vm._v(" mdi-cloud-upload ")]
                              ),
                              _c("input", {
                                staticClass: "hidden",
                                attrs: {
                                  multiple: _vm.multiple,
                                  accept: `${
                                    _vm.fileType.anyFormat
                                  },${_vm.fileType.formats.join(",")}`,
                                  type: "file",
                                  id: "upload-file",
                                  name: "upload-file",
                                },
                                on: {
                                  change: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.fileUploadSubmit(
                                      null,
                                      $event.target.files
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c("p", [
                            _vm._v(
                              "Перетащите вашы файлы сюда или нажмите, чтобы выбрать."
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }